import { isArray } from 'lodash-es';

export default {
  methods: {
    elementIsRequired() {
      const validation = !isArray(this.validation)
        ? [this.validation]
        : this.validation;

      return validation.includes('required');
    },
    elementString(value) {
      if (value && this.elementIsRequired()) {
        return `${value}*`;
      }
      return value;
    },
  },
  computed: {
    elementLabel() {
      return this.elementString(this.label);
    },
    elementPlaceholder() {
      return this.elementString(this.placeholder);
    },
  },
};
